import { SettingsDialogDataProvider } from '../SettingsDialog';
import fallbackSettingsDialogDataProvider from './FallbackSettingsDialogDP';

export const getSettingsDialogDataProvider = (): SettingsDialogDataProvider => {
  return fallbackSettingsDialogDataProvider;
};
